<template>
    <vx-card class="limited-max-width" id="ss-view-covers-donuts">

      <div v-if="commercialOffer.type == 'SOCIALSECURITY'">
        <header-step-process-component
          v-bind:step="step">

        </header-step-process-component>

        <span class="title-style modify-title" style="display:inline-block; margin-bottom:8px"> </span>

        <span class="subtitle-style modify-subtitle" style="display:inline-block; opacity: 0.7;">
        En estos gráficos te mostramos la estimación del porcentaje de cobertura sobre tus ingresos, con el seguro privado y la prestación social.
        En caso de que ocurra alguna de las contingencias, recibirás el capital contratado que figura en la póliza de seguros.
        </span>

        <donut-results-social-security
          v-bind:commercialOffer="commercialOffer"
          v-bind:clientsNeeds="clientsNeeds"
          v-bind:reverseData="reverseData"
          v-bind:code="code"
          v-bind:previus="previus"
        >
        </donut-results-social-security>
      </div>


    </vx-card>
</template>

<script>
/* eslint-disable */
import VxCard from '../../components/vx-card/VxCard.vue'
import HeaderStepProcessComponent from '../components/eprevision-components/header/HeaderStepProcessComponent.vue';
import DonutResultsSocialSecurity from '../components/eprevision-components/donutResultsSocialSecurity/DonutResultsSocialSecurity.vue'
import axios from '../../http/axios/index.js'
export default {
  components: {
      VxCard,
      HeaderStepProcessComponent,
      DonutResultsSocialSecurity
    },
    data() {
      return {
        step: 2,
        code: this.$route.params.code,
        previus: "social-security/fourth",
        dataStored: null,
        commercialOffer: null,
        clientsNeeds: null,
        reverseData: null,
      }
    },
    created() {
      this.$vs.loading.close()

      this.dataStored = JSON.parse(localStorage.getItem(this.code))
      this.commercialOffer = this.dataStored.commercialOffer
      this.clientsNeeds = this.dataStored.clientsNeeds
      this.reverseData = this.dataStored.reverseData

      // this.initVariables()

    },

    methods: {
      // initVariables() {

      //   if(this.reverseData.absolutPermanentDisability) {
      //     this.clientsNeeds.clientsCapitals.filter(x => x.name == "Incapacidad Permanente Absoluta")[0].
      //   }

      // },
    },

}
</script>
